/**
 * Helper functions for token estimation and management
 */

/**
 * A simple approximation function to count tokens
 * @param {string} text - The text to estimate tokens for
 * @returns {number} - Estimated token count
 */
export const estimateTokens = (text) => {
  if (!text) return 0;
  
  // A rough approximation: 1 token is about 4 characters for English text
  // This is a simplification - actual token count depends on the tokenizer
  return Math.ceil(text.length / 4);
};

/**
 * Get limited context from message history for efficient token usage
 * @param {Array} messages - Full message history
 * @param {number} limit - Max number of messages to include (default: 10)
 * @returns {Array} - Limited message history
 */
export const getLimitedMessageContext = (messages, limit = 10) => {
  if (!messages || messages.length === 0) return [];
  
  // If we have fewer messages than the limit, return all
  if (messages.length <= limit) return messages;
  
  // Otherwise return the most recent 'limit' messages
  return messages.slice(-limit);
}; 